import React from "react";
import { useChatStore } from "../../services/ChatStore";
import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddCommentIcon from "@mui/icons-material/AddComment";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function ChatSidebar() {
  const { chats, activeChatId, selectChat, createNewChat, deleteChat } =
    useChatStore();

  const chatHistory = Object.values(chats).sort(
    (a, b) => parseInt(b.id.split("-")[1]) - parseInt(a.id.split("-")[1]),
  );

  const handleDelete = (e, chatId) => {
    e.stopPropagation();
    if (window.confirm("Вы уверены, что хотите удалить этот чат?")) {
      deleteChat(chatId);
    }
  };

  return (
    <Box
      sx={{
        width: 280,
        flexShrink: 0, // <-- 1. ЗАПРЕЩАЕМ СЖИМАТЬСЯ
        height: "100%",
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        borderRight: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}>
      {/* Кнопка "Новый чат" */}
      <Box sx={{ p: 2 }}>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<AddCommentIcon />}
          onClick={createNewChat}>
          Новый чат
        </Button>
      </Box>
      <Divider />

      <Typography variant="overline" sx={{ p: 2, pl: 2 }}>
        История
      </Typography>

      {/* --- 2. ИСПРАВЛЕНИЕ СКРОЛЛБАРА --- */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto", // Оставляем 'auto'

          // Стилизация оверлей-скроллбара (работает в Chrome/Safari/Edge)
          "&::-webkit-scrollbar": {
            width: "6px", // Тонкий скроллбар
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent", // Прозрачный фон
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.2)", // Полупрозрачный
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.3)", // Чуть темнее при наведении
          },

          // Для Firefox (менее красиво, но предотвращает "прыжок")
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(0, 0, 0, 0.2) transparent",
        }}>
        <List dense>
          {chatHistory.map(chat => (
            <ListItemButton
              key={chat.id}
              selected={chat.id === activeChatId}
              onClick={() => selectChat(chat.id)}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "action.hover",
                },
              }}>
              <ListItemText
                primary={chat.title}
                primaryTypographyProps={{
                  noWrap: true,
                  fontSize: "0.9rem",
                }}
              />
              <Tooltip title="Удалить чат">
                <IconButton
                  size="small"
                  onClick={e => handleDelete(e, chat.id)}
                  sx={{
                    opacity: 0.5,
                    "&:hover": { opacity: 1, color: "error.main" },
                  }}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Box>
  );
}
